module.exports = __webpack_public_path__ + "img/undraw_online_calendar_blue.7293b8dc.svg";